import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
// material
import { Box, Radio, RadioGroup } from '@mui/material';
import nobg from "src/assets/nobg.jpg";
// ----------------------------------------------------------------------

IconColor.propTypes = {
  sx: PropTypes.object
};

function IconColor({ sx, ...other }) {
  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        display: 'flex',
        borderRadius: '50%',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'currentColor',
        transition: (theme) =>
          theme.transitions.create('all', {
            duration: theme.transitions.duration.shortest
          }),
        ...sx
      }}
      {...other}
    >
      <Icon icon={checkmarkFill} />
    </Box>
  );
}

ColorSinglePicker.propTypes = {
  colors: PropTypes.array.isRequired
};

export default function ColorSinglePicker({ selected=null, colors, ...other }) {
  return (
    <RadioGroup row {...other}>
      {colors.map((color) => {
        const isWhite = color === '#FFFFFF' || color === 'white';
        const transparent = color === "" || color === "transparent" || color === 'inherit';

        return (
          <Radio
            key={color}
            value={color}
            color="default"
            {...(selected && { checked : selected === color})}
            icon={
              <IconColor
                sx={{
                  ...((isWhite) && {
                    border: (theme) => `solid 1px ${theme.palette.divider}`
                  }),
                  ...((transparent) && {
                    backgroundImage: `url(${nobg})`
                  })
                }}
              />
            }
            checkedIcon={
              <IconColor
                sx={{
                  transform: 'scale(1.4)',
                  '&:before': {
                    opacity: 0.48,
                    width: '100%',
                    content: "''",
                    height: '100%',
                    borderRadius: '50%',
                    position: 'absolute',
                    boxShadow: '4px 4px 8px 0 currentColor',
                     
                  },
                  '& svg': { width: 12, height: 12, color: 'common.white' },
                  ...((isWhite) && {
                    border: (theme) => `solid 1px ${theme.palette.divider}`,
                    boxShadow: (theme) => `4px 4px 8px 0 ${theme.palette.grey[500_24]}`,
                    '& svg': { width: 12, height: 12, color: 'common.black' }
                  }),
                  ...((transparent) && {
                    '& svg': { width: 12, height: 12, color: 'common.white' }
                  })
                }}
              />
            }
            sx={{
              color,
              '&:hover': { opacity: 0.72 }
            }}
          />
        );
      })}
    </RadioGroup>
  );
}
